import {
  emptyString,
  groupsConstants,
  successMessages,
  toastTypes,
} from "../../constants";
import { groupsService } from "../../services";
import { customToast } from "../../../../shared";
import {
  success,
  withSpinner,
  failure,
} from "../../../../redux/actions/utilities";

const {
  REMOVED_SUCCESSFULLY,
  UPDATED_SUCCESSFULLY,
  USER_CREATION_FOR_FRANCHISE,
} = successMessages;

const {
  GROUPS,
  GROUPS_DATA,
  RESET_GROUPS,
  UPDATE_GROUP,
  GROUP_CREATED,
  GET_ALL_LOCATIONS,
  GROUPS_DATA_UPDATE,
  CREATE_SYSTEM_USER,
  GROUP_USER_ADD_ERROR,
  UPDATE_GROUP_RESPONSE,
  RESET_GROUPS_AGAINST_BRAND_ID,
} = groupsConstants;

//Fetching paginated groups data
const getGroupsByBrandId = (queryString, brandId) => {
  return (dispatch) => {
    withSpinner(dispatch, GROUPS_DATA, () =>
      groupsService
        .getGroupsByBrandId(queryString, brandId)
        .then(
          (response) => {
            dispatch(success(response, GROUPS_DATA));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

//Delete Group on the basis of ID
const deleteGroup = (groupId, queryString, brandId) => {
  return (dispatch) => {
    return withSpinner(dispatch, GROUPS_DATA, () =>
      groupsService
        .deleteGroup(groupId)
        .then(
          (_response) => {
            customToast(REMOVED_SUCCESSFULLY, toastTypes.SUCCESS);
            dispatch(emptyAllGroups());
            dispatch(getGroupsByBrandId(queryString, brandId));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
            throw error;
          }
        )
    );
  };
};

//Function to Add Group
const addGroup = (body) => {
  return (dispatch) => {
    withSpinner(dispatch, GROUPS_DATA, () =>
      groupsService
        .addGroup(body)
        .then(
          (response) => {
            customToast(USER_CREATION_FOR_FRANCHISE, toastTypes.SUCCESS);
            dispatch(success(response, GROUP_CREATED));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

//Function to update Group details
const updateGroupDetails = (body, brandId, queryString) => {
  return (dispatch) => {
    withSpinner(dispatch, GROUPS_DATA_UPDATE, () =>
      groupsService
        .updateGroupDetails(body)
        .then(
          (_response) => {
            customToast(UPDATED_SUCCESSFULLY, toastTypes.SUCCESS);
            dispatch(emptyAllGroups());
            dispatch(getGroupsByBrandId({ ...queryString, from: 0 }, brandId));
            dispatch(getLocationByBrandId(brandId));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

//Function to get groups against brand ID
const getGroups = (brandId) => {
  return (dispatch) => {
    withSpinner(dispatch, GROUPS_DATA, () =>
      groupsService
        .getGroups(brandId)
        .then(
          (response) => {
            dispatch(success(response, GROUPS));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

//Function to remove brand location from group
const removeBrandLocation = (brandLocationId, queryString, brandId) => {
  return (dispatch) => {
    return withSpinner(dispatch, GROUPS_DATA, () =>
      groupsService
        .removeBrandLocation(brandLocationId)
        .then(
          (_response) => {
            customToast(REMOVED_SUCCESSFULLY, toastTypes.SUCCESS);
            dispatch(emptyAllGroups());
            dispatch(getGroupsByBrandId(queryString, brandId));
            dispatch(getLocationByBrandId(brandId));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
            throw error;
          }
        )
    );
  };
};

//Empty all groups from redux
const emptyAllGroups = () => {
  return (dispatch) => dispatch(success([], RESET_GROUPS));
};

//Function to get groups against brand ID
const getLocationByBrandId = (brandId) => {
  return (dispatch) => {
    withSpinner(dispatch, GROUPS_DATA, () =>
      groupsService
        .getLocationByBrandId(brandId)
        .then(
          (response) => {
            dispatch(success(response, GET_ALL_LOCATIONS));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

const updateGroup = (id, body) => (dispatch) => {
  withSpinner(dispatch, UPDATE_GROUP, () =>
    groupsService
      .updateGroup(id, body)
      .then(
        (response) => {
          customToast(UPDATED_SUCCESSFULLY, toastTypes.SUCCESS);
          dispatch(emptyAllGroups());
          dispatch(success(response, GROUPS_DATA));
        },
        (error) => {
          dispatch(failure(error[0], UPDATE_GROUP));
          customToast(
            error[0] === CREATE_SYSTEM_USER ? GROUP_USER_ADD_ERROR : error[0],
            toastTypes.ERROR
          );
        }
      )
  );
};

const updateGroupResponse = () => (dispatch) => {
  dispatch(success(emptyString, UPDATE_GROUP_RESPONSE));
};

//Empty all groups of brand id from redux
const emptyAllGroupsAgainstBrandId = () => {
  return (dispatch) => dispatch(success([], RESET_GROUPS_AGAINST_BRAND_ID));
};

//Exporting functions for other files
export const groupsActions = {
  getGroupsByBrandId,
  deleteGroup,
  addGroup,
  getGroups,
  removeBrandLocation,
  emptyAllGroups,
  getLocationByBrandId,
  updateGroup,
  updateGroupResponse,
  updateGroupDetails,
  emptyAllGroupsAgainstBrandId,
};
